import init from './camera/init';

export default init;

(window as any).Anyline = { init };
